module.exports = __webpack_public_path__ + "static/media/watchlist_checkbox_unchecked.eb456a0b.svg";